'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _NewUserOrders = require('../order/NewUserOrders');

var _NewUserOrders2 = _interopRequireDefault(_NewUserOrders);

var _Header = require('../common/Header');

var _Header2 = _interopRequireDefault(_Header);

var _Footer = require('../common/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _Payments = require('./Payments');

var _Payments2 = _interopRequireDefault(_Payments);

var _SavedAddresses = require('./SavedAddresses');

var _SavedAddresses2 = _interopRequireDefault(_SavedAddresses);

var _EditProfileModal = require('../common/EditProfileModal');

var _EditProfileModal2 = _interopRequireDefault(_EditProfileModal);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _StyleGenerator = require('../../utils/StyleGenerator');

var _StyleGenerator2 = _interopRequireDefault(_StyleGenerator);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _SpinButton = require('../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withAccountReactRouter(Component) {
    function ComponentWithAccountReactRouter(props) {
        // const navigate = useNavigate();
        var history = (0, _reactRouterDom.useHistory)();
        var params = (0, _reactRouterDom.useParams)();
        return _react2.default.createElement(Component, _extends({}, props, { history: history, params: params /* other hooks */ }, {
            params: params

        }));
    }
    return ComponentWithAccountReactRouter;
}

var MyAccount = function (_React$Component) {
    _inherits(MyAccount, _React$Component);

    function MyAccount(props, context) {
        _classCallCheck(this, MyAccount);

        var _this = _possibleConstructorReturn(this, (MyAccount.__proto__ || Object.getPrototypeOf(MyAccount)).call(this, props, context));

        _this.hideEditProfile = function (status) {
            return _this.setState({ showEditProfile: false }, function () {
                if (status == true) {
                    _this.populateDetails();
                }
            });
        };

        _this.populateDetails = function () {
            var currentUser = _parse2.default.User.current();

            if (!Utils.isEmptyObj(currentUser)) {
                var phoneNumber = currentUser.get("phoneNumber");

                _this.setState({
                    name: currentUser.get('name'),
                    email: currentUser.get('email'),
                    phoneNumber: Utils.formatPhoneNumber(currentUser.get("phoneNumber"))
                });
            }
        };

        _this.state = {
            showEditProfile: false,
            showOrderComponent: true,
            isMobile: false,
            orderTabActive: true,
            paymentTabActive: false,
            addressTabActive: false
        };

        _this.showOrderComponent = _this.showOrderComponent.bind(_this);
        _this.showPaymentComponent = _this.showPaymentComponent.bind(_this);
        _this.showSavedAddresses = _this.showSavedAddresses.bind(_this);
        _this.getAllDataAndReload = _this.getAllDataAndReload.bind(_this);
        _this.onMainStoreChange = _this.onMainStoreChange.bind(_this);
        _this.hideEditProfile = _this.hideEditProfile.bind(_this);
        _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
        _this.handleOrders = _this.handleOrders.bind(_this);
        _this.handlePayments = _this.handlePayments.bind(_this);
        _this.handleAddresses = _this.handleAddresses.bind(_this);
        _this.updateTabButtonGroupActive = _this.updateTabButtonGroupActive.bind(_this);
        return _this;
    }

    _createClass(MyAccount, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // add the lister of the main store
            _MainStore2.default.listen(this.onMainStoreChange);
            var locId = this.props.params.locId;
            var history = this.props.history;
            var location = history.location;
            this.updateTabButtonGroupActive();
            this.updateWindowDimensions();

            //scroll to top
            window.scrollTo(0, 0);

            if (!location.hasOwnProperty("resetStore")) {
                // when load the main class get all the data and reload
                this.getAllDataAndReload(locId);
            }

            var currentUser = _parse2.default.User.current();

            if (Utils.isEmptyObj(currentUser)) {
                var _history = this.props.history;
                // Navigate to Another Component

                _history.push({
                    pathname: "/location/" + locId,
                    resetStore: false
                });
            } else {
                this.populateDetails();
            }

            this.showProfileModal();
            //add resize browser window listener
            window.addEventListener("resize", this.updateWindowDimensions);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
            if (nextProps) {
                this.showProfileModal();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            //rmeove resize browser window listener
            window.removeEventListener("resize", this.updateWindowDimensions);
        }
    }, {
        key: 'updateWindowDimensions',
        value: function updateWindowDimensions() {

            var width = window.innerWidth;

            this.setState({
                isMobile: width < 993 ? true : false
            });
        }
    }, {
        key: 'updateTabButtonGroupActive',
        value: function updateTabButtonGroupActive() {

            var orderTabActive = false;
            var paymentActive = false;
            var addressTabActive = false;

            if (window.location.href.includes('/orders')) {
                orderTabActive = true;
            } else if (window.location.href.includes('/payments')) {
                paymentActive = true;
            } else if (window.location.href.includes('/addresses')) {
                addressTabActive = true;
            }

            this.setState({
                orderTabActive: orderTabActive,
                paymentTabActive: paymentActive,
                addressTabActive: addressTabActive
            });
        }
    }, {
        key: 'showProfileModal',
        value: function showProfileModal() {
            var url = window.location.href.includes('/profile');

            if (url) {
                this.setState({
                    showEditProfile: true
                });
            }
        }
    }, {
        key: 'getAllDataAndReload',
        value: function getAllDataAndReload() {
            // set the defaultLocationActive state true when location send on the url
            // set location id in the defaultLocId state
            if (this.props.params.locId && this.props.params.locId != null) {
                this.setState({
                    defaultLocationActive: true,
                    defaultLocId: this.props.params.locId
                });

                _Actions2.default.getAllData(null, this.props.params.locId);
            } else {
                _Actions2.default.getAllData();
            }
        }
    }, {
        key: 'onMainStoreChange',
        value: function onMainStoreChange(event, data) {
            var businessDetail = data.BusinessDetail;
            _StyleGenerator2.default.generateGlobalStyleSheet(businessDetail.websiteConfig);

            this.setState({
                showSpinner: false
            });
        }
    }, {
        key: 'showOrderComponent',
        value: function showOrderComponent() {
            this.setState({
                showOrderComponent: true,
                showPaymentComponent: false,
                showSavedAddresses: false
            });
        }
    }, {
        key: 'showPaymentComponent',
        value: function showPaymentComponent() {
            this.setState({
                showPaymentComponent: true,
                showOrderComponent: false,
                showSavedAddresses: false
            });
        }
    }, {
        key: 'showSavedAddresses',
        value: function showSavedAddresses() {
            this.setState({
                showSavedAddresses: true,
                showPaymentComponent: false,
                showOrderComponent: false
            });
        }
    }, {
        key: 'handleOrders',
        value: function handleOrders() {
            var _this2 = this;

            var history = this.props.history;

            this.setState({
                orderTabActive: true,
                paymentTabActive: false,
                addressTabActive: false
            }, function () {
                history.push('/location/' + _this2.props.params.locId + '/orders');
            });
        }
    }, {
        key: 'handlePayments',
        value: function handlePayments() {
            var _this3 = this;

            var history = this.props.history;

            this.setState({
                paymentTabActive: true,
                orderTabActive: false,
                addressTabActive: false
            }, function () {
                history.push('/location/' + _this3.props.params.locId + '/payments');
            });
        }
    }, {
        key: 'handleAddresses',
        value: function handleAddresses() {
            var _this4 = this;

            var history = this.props.history;

            this.setState({
                addressTabActive: true,
                paymentTabActive: false,
                orderTabActive: false
            }, function () {
                history.push('/location/' + _this4.props.params.locId + '/addresses');
            });
        }
    }, {
        key: 'renderTabbedButtons',
        value: function renderTabbedButtons() {
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: "px-4 pb-4" },
                    _react2.default.createElement(
                        'div',
                        { className: 'btn-group w-100 rounded-2' },
                        _react2.default.createElement(_SpinButton2.default, {
                            classNames: 'btn custom-btn-outline-primary px-4 pr-4 ' + (this.state.orderTabActive ? "bg-styl text-white" : ""),
                            buttonText: "Orders",
                            spinText: "",
                            showSpinner: false,
                            whenClicked: this.handleOrders,
                            showIcon: false,
                            tabIndex: 0
                        }),
                        _react2.default.createElement(_SpinButton2.default, {
                            classNames: 'btn custom-btn-outline-primary ' + (this.state.paymentTabActive ? "bg-styl text-white" : ""),
                            buttonText: "Payments",
                            spinText: "",
                            showSpinner: false,
                            whenClicked: this.handlePayments,
                            showIcon: false,
                            tabIndex: 0
                        }),
                        _react2.default.createElement(_SpinButton2.default, {
                            classNames: 'btn custom-btn-outline-primary ' + (this.state.addressTabActive ? "bg-styl text-white" : ""),
                            buttonText: "Addresses",
                            spinText: "",
                            showSpinner: false,
                            whenClicked: this.handleAddresses,
                            showIcon: false,
                            tabIndex: 0
                        })
                    )
                )
            );
        }
    }, {
        key: 'loadMainContent',
        value: function loadMainContent() {
            var _this5 = this;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_Header2.default, null),
                this.state.showEditProfile ? _react2.default.createElement(_EditProfileModal2.default, {
                    history: this.props.history,
                    locId: this.props.params.locId,
                    onHide: this.hideEditProfile.bind(this)
                }) : null,
                _react2.default.createElement(
                    'section',
                    { className: 'section pt-4 pb-4 osahan-account-page', style: { marginTop: "60px" } },
                    _react2.default.createElement(
                        'div',
                        { className: "container inner-body-wrapper" },
                        _react2.default.createElement(
                            'div',
                            { className: "row" },
                            _react2.default.createElement(
                                'div',
                                { className: "order-body-wrapper col-md-3" },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'osahan-account-page-left order-sidebar shadow-sm bg-white' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'p-4 ' + (!this.state.isMobile ? "border-bottom" : "") },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'osahan-user text-center' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'osahan-user-media' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'osahan-user-media-body' },
                                                    _react2.default.createElement(
                                                        'h6',
                                                        { className: 'text-break mb-2' },
                                                        this.state.name
                                                    ),
                                                    _react2.default.createElement(
                                                        'p',
                                                        { className: 'text-break mb-1' },
                                                        this.state.phoneNumber
                                                    ),
                                                    _react2.default.createElement(
                                                        'p',
                                                        { className: "text-break" },
                                                        this.state.email
                                                    ),
                                                    _react2.default.createElement(
                                                        'p',
                                                        { className: 'mb-0 text-black font-weight-bold' },
                                                        _react2.default.createElement(
                                                            _reactRouterDom.Link,
                                                            { to: '#', onClick: function onClick() {
                                                                    return _this5.setState({ showEditProfile: true });
                                                                }, className: 'text-primary mr-3', tabIndex: "7" },
                                                            _react2.default.createElement('i', { className: 'icofont-ui-edit' }),
                                                            ' EDIT'
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    ),
                                    !this.state.isMobile ? _react2.default.createElement(
                                        'ul',
                                        { className: 'nav flex-column border-0 pt-4 pl-4 pb-4' },
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'nav-item', key: "orders" },
                                            _react2.default.createElement(
                                                _reactRouterDom.NavLink,
                                                { className: 'nav-link', tabIndex: 8, activeClassName: 'active', exact: true, to: '/location/' + this.props.params.locId + '/orders' },
                                                _react2.default.createElement('i', { className: 'icofont-food-cart' }),
                                                ' Orders'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'nav-item', key: "payments" },
                                            _react2.default.createElement(
                                                _reactRouterDom.NavLink,
                                                { className: 'nav-link', tabIndex: 9, activeClassName: 'active', exact: true, to: '/location/' + this.props.params.locId + '/payments' },
                                                _react2.default.createElement('i', { className: 'icofont-sale-discount' }),
                                                ' Payments'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'nav-item', key: "addresses" },
                                            _react2.default.createElement(
                                                _reactRouterDom.NavLink,
                                                { className: 'nav-link', tabIndex: 10, activeClassName: 'active', exact: true, to: '/location/' + this.props.params.locId + '/addresses' },
                                                _react2.default.createElement('i', { className: 'icofont-location-pin' }),
                                                ' Addresses'
                                            )
                                        )
                                    ) : this.renderTabbedButtons()
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: "order-body-wrapper h-100 col-md-9" },
                                _react2.default.createElement(
                                    _reactRouterDom.Switch,
                                    null,
                                    _react2.default.createElement(_reactRouterDom.Route, { path: '/location/' + this.props.params.locId + '/orders', render: function render(props) {
                                            return _react2.default.createElement(_NewUserOrders2.default, _extends({}, props, { locId: _this5.props.params.locId, history: _this5.props.history }));
                                        } }),
                                    _react2.default.createElement(_reactRouterDom.Route, { path: '/location/' + this.props.params.locId + '/payments', render: function render(props) {
                                            return _react2.default.createElement(_Payments2.default, _extends({}, props, { locId: _this5.props.params.locId, history: _this5.props.history, isMobile: _this5.state.isMobile }));
                                        } }),
                                    _react2.default.createElement(_reactRouterDom.Route, { path: '/location/' + this.props.params.locId + '/addresses', render: function render(props) {
                                            return _react2.default.createElement(_SavedAddresses2.default, _extends({}, props, { locId: _this5.props.params.locId, history: _this5.props.history, isMobile: _this5.state.isMobile }));
                                        } })
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_Footer2.default, null)
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                this.loadMainContent()
            );
        }
    }]);

    return MyAccount;
}(_react2.default.Component);

//create highter order component.


var HOC_ACCOUNT_NAVIGATION = withAccountReactRouter(MyAccount);
exports.default = HOC_ACCOUNT_NAVIGATION;


//////////////////
// WEBPACK FOOTER
// ./src/components/account/MyAccount.jsx
// module id = 543
// module chunks = 0